import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputDate from '@/components/inputs/InputDate/InputDate.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices } from '@/models/VariousEnum';
import { LastMammo } from '@/models/QuestQuestion';

@Component({
  components: {
    InputText,
    InputDate,
    InputCheckbox,
    InputRadioButton,
  },
})
export default class LastMammoPart extends Vue {
  @Prop({ required: true })
  public value!: LastMammo;
  @Prop({ default: false })
  public readonly!: boolean;
  @Prop({ default: true })
  public required!: boolean;

  public birthDate: Date|null = new Date(this.$store.state.questionnaire.birthdate);

  public answerChoices: any = AnswerChoices;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  /**
   * Get an array of all the property names from the value prop in lowercase
   */
  get instanceFields(): string[] {
    if (this.value) {
      const fields: string[] = [];
      Object.keys(this.value).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }

  /**
   * Get the errors returned by the API corresponding to the model properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      const errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  get showMoreQuestions(): boolean {
    return this.value.flagLastMammo === this.answerChoices.Yes;
  }

  get subQuestionRequired(): boolean {
    return this.value.flagLastMammo === this.answerChoices.Yes;
  }

  get isLastMammoDateValid(): boolean {
    if (this.value.flagLastMammo === AnswerChoices.Yes) {
      const today = new Date();
      const minDate = this.birthDate !== null ? this.birthDate : new Date(today.getFullYear() -100, today.getMonth(), today.getDate());
      const lastMammoDate = this.value.lastMammoDate;
      if (lastMammoDate !== null && minDate !== null && (new Date(lastMammoDate) > today || new Date(lastMammoDate) < minDate)) {
        return false;
      } else if (lastMammoDate !== null && new Date(lastMammoDate) <= today) {
        return true;
      }
    }
    return true;
  }

  protected mounted() {
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: LastMammo, oldValue: LastMammo) {
    if (value) {
      this.$emit('input', value);
    }
  }
}
